import { getBrandName } from '../brand-name';

export function getBrandCopyright() {
  const brandName = getBrandName();
  const currentYear = new Date().getFullYear();

  switch (brandName){
    case 'tennisi':
      return `© 1999–${currentYear}`;
    case 'chesnok':
      return `© ${currentYear}`;
    default:
      assertExhaustiveness(brandName);
  }
}
